import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "./SubjectInfoCreate.module.css";
import Select, { components } from "react-select";
import { customStyles } from "../../../../../pages/customStyles";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import Loader from "../../../Loader";
import moment from "moment";
export default function SubjectInfoCreate() {
  const { id, opType } = useParams();
  // const { idsss, optType } = useParams();
  const [aaOption, AAOption] = useState([
    {
      value: 0,
      label: "Course",
    },
    {
      value: 1,
      label: "Test",
    },
    {
      value: 3,
      label: "Special Class",
    },
    {
      value: 4,
      label: "Model Exam",
    },
    {
      value: 2,
      label: "Counselling",
    },
    {
      value: 5,
      label: "Mock Interview",
    },
  ]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const navigate = useNavigate();
  const [ccategory, setCcategory] = useState([]);
  const [subcategorys, setSubcategorys] = useState([]);
  const [courseLi, setCourseLi] = useState([]);

  const [initialfields, setInitialfields] = useState({
    AAdmissionType: "",
    AAdmissionTypeLabel: "",
    Category: "",
    CategoryTypeLabel: "",
    CourseGrouping: "",
    CourseGrouping_ID: "",
    Subject: "",
    Category_ID: "",
    CourseName: "",
    CourseName_ID: "",
    is_optional: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState({});

  const [subject, setSubject] = useState([]);

  const [subjectTopics, setSubjectTopics] = useState([
    {
      id: 1,
      subject_name: null,
      subject_topics: [],
      subject_name_error: "",
      subject_topics_error: "",
    },
  ]);
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        const ccategory = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));

        setCcategory(ccategory);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    if (initialfields.AAdmissionType !== "" && initialfields.Category_ID) {
      setCourseLi([]);
      AxiosInstance.post("/api/course/courselist", {
        type: [parseInt(initialfields.AAdmissionType)],
        category: [parseInt(initialfields.Category_ID)],
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const SCourseLi = res.data.data.map((item) => ({
                value: item.id,
                label: item.course_name,
                subcategory: item.subcategory,
                subcategory_id: item.subcategory_id,
              }));
              setCourseLi(SCourseLi);
            } else {
              setCourseLi([]);
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [initialfields.AAdmissionType, initialfields.Category_ID]);

  useEffect(() => {
    if (id) {
      const optValue = {
        id: parseInt(id),
        optional_type: parseInt(opType),
      };
      AxiosInstance.post(`api/course/subjectview`, optValue)
        .then((res) => {
          setIsLoading(true);
          if (res.data.status === true) {
            setIsLoading(false);
            let typeLabel;
            if (res.data.data[0].type === 0) {
              typeLabel = "Course";
            } else if (res.data.data[0].type === 1) {
              typeLabel = "Test";
            } else if (res.data.data[0].type === 2) {
              typeLabel = "Counselling";
            } else if (res.data.data[0].type === 3) {
              typeLabel = "SpecialClass";
            } else if (res.data.data[0].type === 4) {
              typeLabel = "ModelExam";
            } else if (res.data.data[0].type === 5) {
              typeLabel = "MockInterview";
            }

            setInitialfields({
              AAdmissionType: res.data.data[0].type,
              AAdmissionTypeLabel: typeLabel,
              Category: res.data.data[0].category_code,
              CategoryTypeLabel: res.data.data[0].category_code,
              CourseGrouping: res.data.data[0].subcategory_code,
              Subject: res.data.data[0].subject_name,
              CourseName: res.data.data[0].course_name,
              CourseName_ID: res.data.data[0].course_id,
              is_optional: res.data.data[0].optional_type,
            });
          } else {
            setIsLoading(false);
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return error;
        });
    } else {
      // Reset fields for create mode
      setInitialfields({
        CategoryTypeLabel: "",
        CourseGroupingLabel: "",
        CourseName: "",
        Category: "",
        CourseGrouping: "",
        AAdmissionType: "",
        content_path: "",
        content_path_original: "",
      });
    }
  }, [id]);

  useEffect(() => {
    if (
      initialfields.Category &&
      initialfields.Subject &&
      initialfields.CourseName
    ) {
      AxiosInstance.post("/api/all/getSubjects", {
        category: initialfields.Category,
        sub_category: initialfields.Subject,
        course_name: initialfields.CourseName,
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const subjectsss = res.data.data.map((item, index) => ({
                value: item.id,
                label: item.subject,
                type: item.type,
                category: item.category,
                subcategory: item.subcategory,
                course_name: item.course_name,
                subject: item.subject,
              }));
              setSubject(subjectsss);
            } else {
              setSubject([]);
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [initialfields.Category, initialfields.Subject, initialfields.CourseName]);

  const handlechangeSelectDropdown = (option, dname) => {
    if (dname === "AAdmissionType") {
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["AAdmissionTypeLabel"]: option.label,
          ["AAdmissionType"]: option.value,
          ["CourseName_ID"]: "",

          ["CourseName"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["AAdmissionTypeLabel"]: "",
          ["AAdmissionType"]: "",
          ["CourseName_ID"]: "",
          ["CourseName"]: "",
        }));
      }
    } else if (dname === "Category") {
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["Category_ID"]: option.value,
          ["Category"]: option.label,
          ["CourseName_ID"]: "",
          ["CourseName"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["Category_ID"]: "",
          ["Category"]: "",
          ["CourseName_ID"]: "",
          ["CourseName"]: "",
        }));
      }
    } else if (dname === "CourseName") {
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["CourseName_ID"]: option.value,
          ["CourseName"]: option.label,
          ["CourseGrouping_ID"]: option.subcategory_id,
          ["CourseGrouping"]: option.subcategory,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["CourseName_ID"]: "",
          ["CourseName"]: "",
          ["CourseGrouping_ID"]: "",
          ["CourseGrouping"]: "",
        }));
      }
    } else if (dname === "Subject") {
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: option.value,
        ["Subject"]: option.label,
      }));

      setError({
        ...error,
        [dname]: "",
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };

  //   const validateFieldss = (data, suTopics) => {
  //     console.log(data, "datadatadatadata");

  //     const errors = {};

  //     if (data.AAdmissionType === "") {
  //       errors.AAdmissionType = "Please select Admission Type.";

  //     }
  //     //  else if (data.Category == "") {
  //     //     alert("hdff")
  //     //   errors.Category = "Please Enter Category.";

  //     // }

  //     else if (!data.CourseName) {
  //       errors.CourseName = "Please Select CourseName.";
  //     } else if (suTopics.length > 0) {
  //       const UpdatesubTopic = suTopics.map((OB) => {
  //         let updatedOB = { ...OB };
  //         if (OB.subject_name === null) {
  //           updatedOB.subject_name_error = "Please Select Subject";
  //         }
  //         if (OB.subject_topics && OB.subject_topics.length === 0) {
  //           updatedOB.subject_topics_error = "Please Select Test Topic";
  //         }

  //         return updatedOB;
  //       });
  //       setSubjectTopics(UpdatesubTopic);
  //     }
  //     return errors;
  //   };

  // Ref
  const subject_ref = useRef(null);
  const type_of_admission_ref = useRef(null);
  const category_ref = useRef(null);
  const course_ref = useRef(null);
  const optional_paper_ref = useRef(null);

  // Error validation
  const validateFieldss = (data, suTopics) => {
    const errors = {};

    if (data.AAdmissionType === "") {
      errors.AAdmissionType = id ? "" : "Please select type of admission";
    }

    if (data.Category === "") {
      errors.Category = id ? "" : "Please select a category";
    }

    if (!data.CourseName) {
      errors.CourseName = id ? "" : "Please select a course";
    }
    if (data.is_optional === undefined || data.is_optional === null) {
      errors.is_optional = "Please select a optional paper";
    }

    if (!data.Subject) {
      errors.Subject = "Please enter subject";
    }
    if (suTopics.length > 0) {
      const UpdatesubTopic = suTopics.map((OB) => {
        let updatedOB = { ...OB };
        if (!OB.subject_name) {
          updatedOB.subject_name_error = "Please select a subject";
        }
        if (!OB.subject_topics || OB.subject_topics.length === 0) {
          updatedOB.subject_topics_error = "Please select a topic";
        }
        return updatedOB;
      });
      setSubjectTopics(UpdatesubTopic);
    }

    validateFocusCommentSection(data, suTopics);
    return errors;
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.Subject) {
      subject_ref.current.focus();
    } else if (!COMSECFO.AAdmissionType) {
      type_of_admission_ref.current.focus();
    } else if (!COMSECFO.Category) {
      category_ref.current.focus();
    } else if (!COMSECFO.CourseName) {
      course_ref.current.focus();
    } else if (!COMSECFO.is_optional) {
      optional_paper_ref.current.focus();
    }
  };

  const handleSubmit = () => {
    const err_bnh = validateFieldss(initialfields, subjectTopics);

    const subjectsArray = initialfields.Subject
      ? initialfields.Subject?.split(",").map((item) => item.trim())
      : [];
    const subjectArrayList = (initialfields.Subject || "")
      .split(",")
      .map((item) => item.trim().toLowerCase())
      .filter((item) => item);

    const tmp = {};
    const duplicates = [];
    function formatWithAnd(arr) {
      if (arr.length <= 1) return arr.join("");
      if (arr.length === 2) return `${arr[0]} and ${arr[1]}`;
      return `${arr.slice(0, -1).join(", ")}, and ${arr[arr.length - 1]}`;
    }
    for (const subject of subjectArrayList) {
      if (tmp[subject]) {
        if (!duplicates.includes(subject)) {
          duplicates.push(subject);
        }
      } else {
        tmp[subject] = true;
      }
    }
    if (duplicates.length > 0) {
      err_bnh.Subject = `${formatWithAnd(
        duplicates
      )}   are listed more than once. Please review and remove duplicates.`;
    }

    if (!initialfields.Subject || initialfields.Subject.trim() === "") {
      err_bnh.Subject = "Please enter at least one subject";
    }
    // Check for specific validation cases
    if (!initialfields.Subject || initialfields.Subject.trim() === "") {
      err_bnh.Subject = "Please enter at least one subject";
    } else if (
      initialfields.Subject.startsWith(",") ||
      initialfields.Subject.endsWith(",")
    ) {
      err_bnh.Subject = "Subject cannot start or end with a comma";
    } else if (subjectsArray.some((item) => item === "")) {
      err_bnh.Subject = "Subject cannot contain empty values between commas";
    } else if (subjectsArray.some((item) => !item.trim())) {
      err_bnh.Subject = "Subject values cannot have extra spaces only";
    } else if (subjectsArray.length > 20) {
      err_bnh.Subject = "You can only provide up to 20 subjects";
    }

    // If there are validation errors, set them and return early
    if (Object.keys(err_bnh).length > 0) {
      setError(err_bnh);
      return;
    }

    try {
      if (id) {
        // If an id is provided, update the data
        const updateCoures = {
          id: parseInt(id),
          optional_type: parseInt(opType),
          subject_name: initialfields.Subject,
          course_id: initialfields.CourseName_ID,
        };

        AxiosInstance.post(`api/course/subjectEdit/`, updateCoures)
          .then((res) => {
            if (res.data.status) {
              toast.success(res.data.message);
              navigate(-1);
            } else {
              if (res.data?.subject_name_error) {
                setError((prev) => ({
                  ...prev,
                  Subject: res.data.subject_name_error,
                }));
              } else {
                toast.error(res.data.message);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // If no id is provided, add the new data
        const createCouresInfoData = {
          subject: subjectsArray,
          type: initialfields.AAdmissionType,
          subcategory: initialfields.CourseGrouping,
          course_name: initialfields.CourseName,
          course_id: initialfields.CourseName_ID,
          category: initialfields.Category,
          optional_type: parseInt(initialfields.is_optional),
          created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid,
        };

        AxiosInstance.post(`api/course/subjectAdd`, createCouresInfoData)
          .then((res) => {
            if (res.data.status) {
              toast.success(res.data.message);
              navigate("/CourseManagement/2");
            } else {
              if (res.data?.subject_name_error) {
                setError((prev) => ({
                  ...prev,
                  Subject: res.data.subject_name_error,
                }));
              } else {
                toast.error(res.data.message);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Subject" : "Create New Subject"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/CourseManagement/2"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Subject" : "Back to Course Management"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Subject
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Subject Details</legend>
            <form className="row g-3">
              <div class="col-12">
                <label
                  for="highlight_of_fact"
                  class="form-label confirm_value "
                >
                  Subject{" "}
                  {!id
                    ? "(You can add up to 20  subjects, separated by commas)"
                    : ""}
                </label>
                <textarea
                  ref={subject_ref}
                  className={`${createInfo.desc_input} w-100 rounded p-2 input-font-size`}
                  placeholder={
                    !id
                      ? "You can add up to 20  subjects, separated by commas"
                      : ""
                  }
                  id="highlight_of_fact"
                  onChange={(e) => handleChange(e)}
                  value={initialfields.Subject}
                  name="Subject"
                  maxLength={500}
                  style={{
                    height: "auto",
                    minHeight: "calc(24px * 8)",
                  }}
                ></textarea>
                {error.Subject && (
                  <small className={createInfo.errors}>{error.Subject}</small>
                )}
                {/* {error.highlight_of_fact && (
                  <span className="error_message">
                    {error.highlight_of_fact}
                  </span>
                )} */}
              </div>
              <div className="col-md-6">
                <label
                  for="AAdmissionType"
                  className="form-label confirm_value"
                >
                  Type of Admission
                </label>
                <Select
                  ref={type_of_admission_ref}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="AAdmissionType"
                  value={
                    initialfields.AAdmissionTypeLabel !== null &&
                    initialfields.AAdmissionType !== ""
                      ? {
                          value: initialfields.AAdmissionType,
                          label: initialfields.AAdmissionTypeLabel,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "AAdmissionType")
                  }
                  options={aaOption}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Admission Type"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />
                {error.AAdmissionType && (
                  <small className={createInfo.errors}>
                    {error.AAdmissionType}
                  </small>
                )}
              </div>
              <div class="col-md-6">
                <label for="Category" class="form-label confirm_value ">
                  Category
                </label>
                <Select
                  ref={category_ref}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="Category"
                  value={
                    initialfields.Category !== null &&
                    initialfields.Category !== ""
                      ? {
                          value: initialfields.Category_ID,
                          label: initialfields.Category,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "Category")
                  }
                  options={ccategory}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Category"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles}
                />

                {error.Category && (
                  <small className={createInfo.errors}>{error.Category}</small>
                )}
              </div>
              {console.log(
                initialfields.CourseName_ID,
                "myNameqqw",
                initialfields.CourseName
              )}
              <div class="col-md-6">
                <label for="CourseGrouping" class="form-label confirm_value ">
                  Course
                </label>
                <Select
                  ref={course_ref}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="CourseName"
                  value={
                    initialfields.CourseName !== null &&
                    initialfields.CourseName !== ""
                      ? {
                          value: initialfields.CourseName_ID,
                          label: initialfields.CourseName,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "CourseName")
                  }
                  options={courseLi
                    .filter((item) => item && item.label) // Filter out null and undefined elements
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Course"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles}
                />
                {error.CourseName && (
                  <small className={createInfo.errors}>
                    {error.CourseName}
                  </small>
                )}
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="examName"
                  className="form-label confirm_value"
                  isDisabled={id ? true : false}
                >
                  Optional Paper
                </label>

                <div>
                  <input
                    ref={optional_paper_ref}
                    className={`shadow-none input-font-size ${
                      id ? "disabled_btn" : ""
                    } ${createInfo.checkbox_radio}`}
                    // isDisabled={id ? true : false}
                    disabled={!!id}
                    type="radio"
                    checked={initialfields.is_optional == 1 ? true : false}
                    id="yes"
                    name="is_optional"
                    value={1}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="yes"
                    className={`${createInfo.margin_right} form-label confirm_value`}
                  >
                    Yes
                  </label>

                  <input
                    ref={optional_paper_ref}
                    className={`shadow-none input-font-size ${
                      id ? "disabled_btn" : ""
                    } ${createInfo.checkbox_radio}`}
                    //  isDisabled={id ? true : false}
                    disabled={!!id}
                    type="radio"
                    id="no"
                    name="is_optional"
                    value={0}
                    checked={initialfields.is_optional == 0 ? true : false}
                    onChange={handleChange}
                  />
                  <label htmlFor="no" className="form-label confirm_value">
                    No
                  </label>
                </div>
                {error.is_optional && (
                  <small className={createInfo.errors}>
                    {error.is_optional}
                  </small>
                )}
                {/* Error message for radio input */}
                {/* {error.is_combined && (
                        <p className="text-danger input-font-size">
                          {error.is_combined}
                        </p>
                      )} */}
              </div>
              {/* <div class="col-md-6">
                <label for="CourseName" class="form-label confirm_value ">
                  Course Name
                </label>
                <input
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="CourseName"
                  name="CourseName"
                  placeholder="Enter the Course name"
                  value={initialfields.CourseName}
                  onChange={handleChange}
                />
              </div> */}
            </form>
          </fieldset>
          {/* {subjectTopics.length > 0 &&
            subjectTopics.map((item, index) => (
              <AddSubjectTopics
                key={item.id}
                length={subjectTopics.length}
                AddSubTop={AddSubTop}
                deleteSubTop={deleteSubTop}
                subject_test={subject}
                record={item}
                handleSubjectOptionChange={handleSubjectOptionChange}
                cate={initialfields.Category}
                subcate={initialfields.CourseGroupingLabel}
                course_name={initialfields.CourseName}
              />
            ))} */}
          <div className="offset-md-12 col-12 ListBtn pt-2">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={id ? "javascript:void(0)" : "/CourseManagement/2"}
                  onClick={id ? navigateToPreviousScreen : () => {}}
                  className="secondaryButton "
                  variant="secondary"
                >
                  {id ? "Back to View Subject" : "Back to Course Management"}
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={handleSubmit}
                  className="primaryButton text-center "
                  variant="primary"
                >
                  Save Subject
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
